import { memo } from 'react';
import FavoriteProductButton from 'components/FavoriteProductButton';
import ProductVariantButton from 'components/ProductVariantButton';
import getPercentOrMg from 'utils/get-percent-or-mg';
import styles from './ProductVariants.module.scss';

function ProductVariants({
  brand,
  category,
  handleToggleFavorite,
  isFavorite,
  productName,
  selectedSKU,
  setSelectedVariant,
  storeSelection,
  variants,
  variationLabel,
}) {
  const sortedVariants = variants
    .filter(
      (v) => v && v.variation && v.variation !== 'N/A' && v.variation !== 'none'
    )
    .sort((a, b) => {
      const aSortRank = a.sortRank;
      const bSortRank = b.sortRank;
      const aThc = Number.parseFloat(a.percentTHC ?? a.mgTHC ?? 0);
      const bThc = Number.parseFloat(b.percentTHC ?? b.mgTHC ?? 0);
      if (
        aSortRank === bSortRank &&
        !Number.isNaN(aThc) &&
        !Number.isNaN(bThc)
      ) {
        return aThc - bThc;
      }
      return aSortRank - bSortRank;
    });

  const isShowVariants =
    sortedVariants.length > 1 ||
    (sortedVariants.length > 0 && category !== 'accessories');

  return (
    <section className="d-flex flex-column">
      <strong
        className={`font-roboto fw-600 fs-6 mb-0 text-primary text-uppercase ${styles.brand}`}
      >
        {brand}
      </strong>

      <div className="d-flex flex-row align-items-start">
        <h1
          className="font-frl fw-400 fs-18 fs-xl-20 fs-xxl-22 mb-15 text-primary"
          data-value="pdp-product-name"
        >
          {productName}
        </h1>
        <div className={styles.heart_container}>
          <FavoriteProductButton
            className={styles.heart_icon}
            isFavorite={isFavorite}
            handleButtonClick={handleToggleFavorite}
          />
        </div>
      </div>
      {isShowVariants ? (
        <>
          <h4 className="font-roboto fw-600 fs-6 text-uppercase text-grey-darker">
            {variationLabel}
          </h4>

          <ul className={styles.variants_grid}>
            {sortedVariants.map((variant) => {
              const {
                variation: label,
                inStock,
                mgTHC,
                percentTHC,
                SKU,
              } = variant;

              const thcInfo = getPercentOrMg(percentTHC, mgTHC);

              const variantLabel =
                category === 'flower' && (mgTHC || percentTHC)
                  ? `${label} - ${thcInfo}`
                  : label;

              return (
                <li key={SKU}>
                  <ProductVariantButton
                    inStock={inStock}
                    label={variantLabel}
                    selectedSKU={selectedSKU}
                    SKU={SKU}
                    storeSelection={storeSelection}
                    onClick={() => setSelectedVariant(variant)}
                  />
                </li>
              );
            })}
          </ul>
        </>
      ) : null}
    </section>
  );
}

export default memo(ProductVariants);
